import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";

import RoomControlPanel from "../components/roomcontrol";
import HeatingControl from "../components/heatingcontrol";
import MainControl from "../components/maincontrol";
import chaletStore from "../state/chaletstore";
import { connectws } from '../data/wsclient';
import { WS_URL } from '../data/apiconfig';

export const HomePage = ({ children }: any) => {


  const setLastUpdate = chaletStore((state) => state.setLastUpdate)
  const updateRoom = chaletStore((state) => state.updateRoom)
  const updateDevice = chaletStore((state) => state.updateDevice)
  const updateLight = chaletStore((state) => state.updateLight)
  const fetchInitialState = chaletStore((state) => state.fetchInitialState)
  const isInitialized = chaletStore((state) => state.data.isInitilized)
  const loadError = chaletStore((state) => state.loadError)

  useEffect(() => {
    if (!chaletStore.getState().data.isInitilized) {
      fetchInitialState()
    }
  }, []);

  // live updates only after the snapshot is loaded, otherwise they hit an empty store
  useEffect(() => {
    if (isInitialized) {
      connectws(WS_URL, setLastUpdate, updateRoom, updateDevice, updateLight)
    }
  }, [isInitialized]);

  return (
    <Container className="pt-5 pb-5 ">
      {!isInitialized && (
        <Row className="justify-content-center pb-3">
          <Col className="col-lg-6 col-xs-auto">
            {loadError ? (
              <Alert variant="warning">Could not load the current state ({loadError}). Retrying…</Alert>
            ) : (
              <Alert variant="info">Loading current state…</Alert>
            )}
          </Col>
        </Row>
      )}
      <Row className="justify-content-center pb-5">
        <Col className="col-lg-6 col-xs-auto">
          <MainControl />
        </Col>
      </Row>
      <Row className="justify-content-center pt-5">
        <Col className="col-lg-6 col-12">
          <RoomControlPanel />
        </Col>
        <Col className="col-lg-6 col-12">
          <HeatingControl />
        </Col>
      </Row>
    </Container>
  );
};
